export default "__VITE_ASSET__BfDpNmIU__"